import { ProductSize } from "./ProductSize.js";

export const defaultSize = ProductSize.M;
